import { Joi, objectSchemaOf } from '../helpers';

export interface IUserClaims {
  isConsole: boolean;
  isHil: boolean;
  isAdmin: boolean;
  isOrgAdmin: boolean;
  isOrgStaff: boolean;
  staffId?: string;
  organisationId: string;
}

export interface IStaffUserClaims {
  isOrgAdmin: boolean;
  isOrgStaff: boolean;
  staffId: string;
  organisationId: string;
}

export interface IServiceClaims {
  isCluster: boolean;
  isPremise: boolean;
}

export const userClaimsSchema = objectSchemaOf<IUserClaims>({
  organisationId: Joi.string().required(),
  isAdmin: Joi.boolean(),
  isHil: Joi.boolean(),
  isConsole: Joi.boolean(),
  isOrgAdmin: Joi.boolean(),
  isOrgStaff: Joi.boolean(),
  staffId: Joi.string(),
}).unknown(true);

export const staffMemberClaimsSchema = objectSchemaOf<IStaffUserClaims>({
  organisationId: Joi.string().required(),
  isOrgAdmin: Joi.boolean().required(),
  isOrgStaff: Joi.boolean().required(),
  staffId: Joi.string().required(),
}).unknown(true);

export const falsyClaimValues: IUserClaims = {
  isConsole: false,
  isHil: false,
  isAdmin: false,
  isOrgAdmin: false,
  isOrgStaff: false,
  organisationId: '',
};
